// extracted by mini-css-extract-plugin
export default {"ContactType":"ContactType_ContactType__QOoCH"};